import WebRTCPlayer from './WebRTCPlayer.vue';
export default WebRTCPlayer;
